import { render } from "./RegisterView.vue?vue&type=template&id=7e674562&ts=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"

import "./RegisterView.vue?vue&type=style&index=0&id=7e674562&lang=scss"

import exportComponent from "/home/jesse/Documenten/node/scavenger/shroom-christmas-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__